import { Alert, Button, Input, Select, Typography } from 'antd';

import type { RecommendBindingConflict } from '@app/api/RecommendChat';
import { getRecommendChatReason } from '@app/api/RecommendChat';

import { useLoyaltyBindingConflict } from '../hooks/useLoyaltyBindingConflict';

import type { FC } from 'react';

import './LoyaltyBindingConflictItem.scss';

interface LoyaltyBindingConflictItemProps {
  conflict: RecommendBindingConflict;
  onResolved(): void;
}

export const LoyaltyBindingConflictItem: FC<LoyaltyBindingConflictItemProps> = (
  props
) => {
  const {
    options,
    selection,
    reason,
    error,
    resultText,
    isLoading,
    canResolve,
    selectionChangeHandler,
    reasonChangeHandler,
    resolveHandler,
  } = useLoyaltyBindingConflict(props);
  return (
    <div className="LoyaltyBindingConflictItem">
      <Typography.Text strong>
        {props.conflict.displayName || 'Пользователь Рекомендуй'}
      </Typography.Text>
      {['UNVERIFIED_CONTACT_MATCH', 'CRM_RELATION_REQUIRED'].includes(
        props.conflict.reasonCode
      ) && (
        <Alert
          type="warning"
          message={getRecommendChatReason(props.conflict.reasonCode)}
          showIcon
        />
      )}
      <Typography.Paragraph type="secondary">
        Выберите существующего клиента для обращения. Его прежняя история не
        передаётся в приложение.
      </Typography.Paragraph>
      <Select
        aria-label="Клиент для обращения"
        value={selection}
        options={options}
        onChange={selectionChangeHandler}
        placeholder="Выберите существующего клиента"
        disabled={isLoading || !options.length}
        showSearch
        optionFilterProp="label"
      />
      {!options.length && (
        <Typography.Text type="secondary">
          Нет доступных клиентов для привязки.
        </Typography.Text>
      )}
      <Input.TextArea
        aria-label="Основание привязки"
        value={reason}
        onChange={({ target }) => reasonChangeHandler(target.value)}
        placeholder="Основание привязки"
        maxLength={1000}
        autoSize={{ minRows: 2, maxRows: 4 }}
        disabled={isLoading}
      />
      {error && <Alert type="error" message={error} showIcon />}
      {resultText && <Alert type="info" message={resultText} />}
      <Button
        onClick={resolveHandler}
        disabled={!canResolve}
        loading={isLoading}
      >
        Применить решение
      </Button>
    </div>
  );
};
